export type CustomShortCodeModel = {
  id: number,
  key: string,
  owner_id: number,
  owner_type: string,
  title: string,
  value: string,
}

export type CustomShortCodeRequestOptions = {}

const state = {
  id: null,
  key: '',
  owner_id: undefined,
  owner_type: '',
  title: '',
  value: '',
}

export const requiredFields = [
  { key: 'key', validation: (value: string) => /^[a-z]+(?:_+[a-z]+)*$/.test(value), invalidMessage: 'a-z and _ only' },
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'title' },
  { key: 'value' },
]

export default state
